import { render, staticRenderFns } from "./nindex.vue?vue&type=template&id=1c148e70&"
import script from "./nindex.vue?vue&type=script&lang=js&"
export * from "./nindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports